export default __webpack_public_path__ + "static/media/staking-btn.77f76e1b.svg";